"use client";

import { useEffect } from "react";
import { useAppContext } from "~/contexts/AppContext";
import { setEntityGAContext } from "~/utils/googleAnalyticsUtils";

/**
 * Sets the module-level entity (facility) context in googleAnalyticsUtils so
 * every event carries entity_id / entity_name — including on the facility page
 * where there is no course (course_name stays "(not set)" there, but the event
 * is still attributable by entity). The entity is fixed per domain, so this is
 * set once and not reset.
 */
const EntityGAContextSync = () => {
  const { entity } = useAppContext();
  const entityId = entity?.id;
  const entityName = entity?.name;

  useEffect(() => {
    setEntityGAContext({ entityId, entityName });
  }, [entityId, entityName]);

  return null;
};

export default EntityGAContextSync;
